<!--
	Render a list of testimonial items
-->
<template>
	<div class="mia-Testimonials">
		<h1 v-tr="'testimonials_section_title'" class="mia-TestimonialsHeader mia-Heading" />
		<list-store-registration :store="listStore" :initial-data="initialData" />
		<conversion-store-registration :store="conversionStore" :initial-conversions="conversions" />
		<vue-list
			:items="listStore"
			class="mia-TestimonialsSwiperContainer"
			:conversions="conversionStore"
			template="testimonial"
		/>
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import VueList from "../Lists/VueList/VueList.vue";
import ListStoreRegistration from "../Stores/VueList/ListStoreRegistration";
import { MiaPlaza } from "../../../Reinforced.Typings";
import ConversionStoreRegistration from "../Stores/VueList/ConversionStoreRegistration";

@Component({
	components: {
		ConversionStoreRegistration,
		ListStoreRegistration,
		VueList,
	},
})
export class TestimonialsPanel extends Vue {
	@Prop({ required: true, type: Array }) private testimonials!: MiaPlaza.LO.Testimonials.ITestimonial[];

	listStore = `testimonial-list`;
	conversionStore = `testimonial-conversion`;

	get conversions() {
		return {...this.testimonials};
	}

	get initialData() {
		return {
			Items: this.testimonials.map((_, index) => index),
			TotalCountEstimate: this.testimonials.length, 
			UnfilteredLimit: 0, 
			UnfilteredOffset: 0
		};
	}
}

export default toNative(TestimonialsPanel);
</script>

<style lang="scss">
$mia-testimonials-header-font-size-xs: 30px;
$mia-testimonials-header-font-size-md: 40px;

.mia-PanelContainer:has(.mia-Testimonials) {
	padding: 0;
}

.mia-Testimonials {
	padding-top: theme.$mia-padding-panel-huge;

	.mia-TestimonialsHeader {
		text-align: center;
		margin: 0;

		@media(max-width: theme.$screen-xs-max) {
			font-size: $mia-testimonials-header-font-size-xs;
		}

		@media(min-width: theme.$screen-md-min) {
			font-size: $mia-testimonials-header-font-size-md;
		}
	}

	.mia-TestimonialsSwiperContainer {
		.swiper .swiper-wrapper {
			padding-bottom: theme.$mia-padding-panel-huge !important;
		}

		swiper-slide {
			// This is needed to override height set by swiper-list.
			height: auto !important; 
			align-self: stretch;
			padding-top: theme.$mia-padding-panel-xl;
			padding-bottom: theme.$mia-padding-panel-huge;
		}
	}
}
</style>
